/*
 * cart-upsell.js
 *
 * Wires the cart drawer upsell "+ ADD TO THE CART" button. Adds the
 * configured variant (with optional selling plan) via /cart/add.js and
 * morphs the drawer using Horizon's `cart:update` event.
 *
 * Uses event delegation on `document`, so it survives Horizon's section
 * morphing without re-binding. Feature-scoped: it does NOT touch the core
 * cart web components or their handlers.
 */
if (!window.__cartUpsellInit) {
  window.__cartUpsellInit = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.cart-upsell-add');
    if (!btn) return;

    event.preventDefault();
    if (btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) {
      console.warn('[cart-upsell] missing data-variant-id');
      return;
    }

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';

    try {
      // Collect the live cart section id(s) so the add response includes the
      // rendered section HTML that Horizon needs to morph the drawer.
      const sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
        const id = el.getAttribute('data-section-id');
        if (id && !sectionIds.includes(id)) sectionIds.push(id);
      });

      const body = { id: variantId, quantity: 1 };
      if (btn.dataset.sellingPlan) body.selling_plan = btn.dataset.sellingPlan;
      if (sectionIds.length) {
        body.sections = sectionIds.join(',');
        body.sections_url = window.location.pathname;
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error('add failed: ' + res.status);
      const data = await res.json();

      // Mimic Horizon's CartAddEvent shape so cart-items-component morphs in
      // the new section HTML (which also re-hides this upsell, now in cart).
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'cart-upsell-add',
            data: { source: 'cart-upsell-add', sections: data.sections },
          },
        })
      );

      btn.textContent = '✓ Added';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1200);
    } catch (err) {
      console.error('[cart-upsell] add failed', err);
      btn.textContent = 'Try again';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  });
}
